"use client"

import { useEffect, useState } from "react"

export default function Alert({
  type = "info", // success | error | warning | info
  title = "",
  message = "",
  show = false,
  onClose,
  autoClose = true,
  duration = 3000,
}) {
  const [visible, setVisible] = useState(show)
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    setVisible(show)
    setAnimating(true)

    if (show && autoClose) {
      const timer = setTimeout(() => {
        handleClose()
      }, duration)
      return () => clearTimeout(timer)
    } // eslint-disable-next-line
  }, [show, autoClose, duration])

  const handleClose = () => {
    setAnimating(false)
    setTimeout(() => {
      setVisible(false)
      onClose?.()
    }, 250)
  }

  if (!visible) return null

  const variants = {
    success: {
      icon: "✅",
      bg: "#ECFDF5",
      border: "#D1FAE5",
      text: "#065F46",
    },
    error: {
      icon: "❌",
      bg: "#FEE2E2",
      border: "#FCA5A5",
      text: "#991B1B",
    },
    warning: {
      icon: "⚠️",
      bg: "#FEF3C7",
      border: "#FCD34D",
      text: "#92400E",
    },
    info: {
      icon: "ℹ️",
      bg: "#FEF9C3",
      border: "#FDE68A",
      text: "#78350F",
    },
  }

  const { icon, bg, border, text } = variants[type] || variants.info

  return (
    <div
      style={{
        position: "fixed",
        bottom: "1.25rem",
        right: "1.25rem",
        zIndex: 9999,
        backgroundColor: bg,
        border: `1px solid ${border}`,
        color: text,
        padding: "0.4rem 0.8rem",
        borderRadius: "0.5rem",
        boxShadow: "0 4px 12px rgba(245, 229, 6, 0.1)",
        width: "270px",
        fontSize: "0.80rem",
        display: "flex",
        alignItems: "flex-start",
        gap: "0.4rem",
        transform: animating ? "translateX(0)" : "translateX(20px)",
        opacity: animating ? 1 : 0,
        transition: "all 0.3s ease-in-out",
      }}
    >
      <span style={{ fontSize: "0.63rem", lineHeight: "1.92" }}>{icon}</span>
      <div style={{ flex: 1 }}>
        {title && <p style={{ fontWeight: "600",  fontFamily: "'Inter', sans-serif", marginBottom: "0.2rem" }}>{title}</p>}
        <p style={{ fontSize: "0.8rem",fontFamily: "'Inter', sans-serif", lineHeight: "1.2", color:"#78350F" }}>{message}</p>
      </div>
      <button
        onClick={handleClose}
        aria-label="Close"
        style={{
          background: "transparent",
          border: "none",
          fontSize: "0.9rem",
          color: text,
          cursor: "pointer",
          padding: "0 0.25rem",
        }}
      >
        &times;
      </button>
    </div>
  )
}
